import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { token } from '@atlaskit/tokens';
import type { issueTotalCount_softwareReleasesVersionDetailIssueList$key } from './__generated__/issueTotalCount_softwareReleasesVersionDetailIssueList.graphql';

interface Props {
	jiraVersion: issueTotalCount_softwareReleasesVersionDetailIssueList$key;
}

export const IssueTotalCount = ({ jiraVersion }: Props): React.JSX.Element => {
	const data = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment issueTotalCount_softwareReleasesVersionDetailIssueList on JiraVersion {
				allIssuesRedesignTemp: issues @required(action: THROW) {
					totalCount @required(action: THROW)
				}
			}
		`,
		jiraVersion,
	);

	return <TotalCountLozenge>{data.allIssuesRedesignTemp.totalCount}</TotalCountLozenge>;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TotalCountLozenge = styled.div({
	backgroundColor: token('color.background.accent.gray.subtlest'),

	font: token('font.body.small'),
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '16px',
	borderRadius: token('radius.large'),
	// This margin is to align vertically, due to font style, 2 pixels are misaligned that looks not right.
	marginTop: token('space.025'),
	paddingRight: token('space.050'),
	paddingLeft: token('space.050'),
});
